export default {
  title: 'Sviluppatori',
  subtitle: 'Chiavi API, webhook e cronologia consegne per la tua integrazione Partner API.',
  no_account: 'Nessun account Partner API ancora — contatta Foodamigos per farne attivare uno.',
  no_account_manage: 'Nessun account Partner API ancora — creane uno per iniziare a emettere chiavi.',
  buttons: {
    new_account: 'Nuovo account',
    edit_account: 'Modifica account',
    docs: 'Documentazione API',
  },
  tabs: {
    api_keys: 'Chiavi API',
    webhooks: 'Webhook',
    deliveries: 'Consegne',
  },
  toasts: {
    load_error: 'Impossibile caricare i tuoi account Partner API.',
  },
};
